import 'css-chunksrc/client/common/dragAndDrop/dropBox/styles.scss';export default {
  "dropBox": "_dropBox_7o6r8_1",
  "hitBox": "_hitBox_7o6r8_5"
};